import React from 'react';
import Button from '../common/Button';
import { useLanguage } from '../../contexts/LanguageContext';
import './Hero.css';

const Hero = () => {
    const { t } = useLanguage();

    return (
        <section className="hero" aria-labelledby="hero-title">
            <div className="hero__bg-gradient" aria-hidden="true"></div>
            <div className="hero__container">
                <div className="hero__grid">
                    <div className="hero__content animate-fade-in-up">

                        <h1 id="hero-title" className="hero__title">
                            {t('hero.welcome')}
                        </h1>
                        <p className="hero__subtitle">
                            {t('hero.subtitle')}
                        </p>
                        <div className="hero__actions">
                            <Button size="lg" href="/departments">
                                {t('hero.explore')}
                            </Button>
                            <Button variant="secondary" size="lg" href="/contact">
                                {t('hero.contact')}
                            </Button>
                        </div>
                        <div className="hero__stats">
                            <div className="hero__stat">
                                <span className="hero__stat-number">2,000+</span>
                                <span className="hero__stat-label">Graduates</span>
                            </div>
                            <div className="hero__stat-divider"></div>
                            <div className="hero__stat">
                                <span className="hero__stat-number">4</span>
                                <span className="hero__stat-label">Departments</span>
                            </div>
                            <div className="hero__stat-divider"></div>
                            <div className="hero__stat">
                                <span className="hero__stat-number">10+</span>
                                <span className="hero__stat-label">Years</span>
                            </div>
                        </div>
                    </div>
                    <div className="hero__visual">
                        <div className="hero__image-wrapper">
                            <div className="hero__image-bg"></div>
                        </div>
                        <div className="hero__floating-card">
                            <div className="hero__floating-card-icon">
                                <span className="material-icons">workspace_premium</span>
                            </div>
                            <div>
                                <p className="hero__floating-card-title">Top Rated</p>
                                <p className="hero__floating-card-desc">Excellence in Education</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
